import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Images
import Logo from '../../images/logo.png';
import footerBg from '../../images/background/footer.jpg';
import ptImg1 from '../../images/shap/wave-blue.png';
import ptImg2 from '../../images/shap/circle-dots.png';
import ptImg3 from '../../images/shap/plus-blue.png';
import ptImg4 from '../../images/shap/wave-blue.png';

// Social Images
import instagram from '../../images/social/instagram.png';

class aboutSection extends Component{
	render(){
		return(
			<>
				
				<footer className="footer" style={{backgroundImage: "url("+footerBg+")"}}>
					<div className="footer-top">
						<div className="container">
							<div className="row">
								<div className="col-xl-3 col-lg-3 col-md-6">
									<div className="widget widget_info">
										<div className="footer-logo">
											<h3>Utopia Dental Clinic</h3>
										</div>
										<div className="ft-contact">
											<p>Av. Corrientes 5441, CABA</p>
											<div className="contact-bx">
												<div className="icon"><i className="fas fa-phone-alt"></i></div>
												<div className="contact-number">
													<span>Contactanos</span>
													<a href="https://wa.me/5491137774576?text=Hola,%20me%20gustaría%20agendar%20un%20turno" target="_blank" rel="noopener noreferrer"><h4 className="number">+54 11 3777 4576</h4></a>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-6">
									<div className="widget footer_widget ml-50">
										<h3 className="footer-title">Enlaces</h3>
										<ul>
											<li><Link to="/">Nosotros</Link></li>
											<li><Link to="/"><span>Faq's</span></Link></li>
											<li><Link to="/"><span>Contacto</span></Link></li>
										</ul>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-6">
									<div className="widget footer_widget">
										<h3 className="footer-title">Especialidades</h3>
										<ul>
											<li><span>Ortodoncia</span></li>
											<li><span>Periodoncia</span></li>
											<li><span>Protesis</span></li>
											<li><span>Implantología</span></li>
											<li><span>Cirugia</span></li>
											<li><span>ATM</span></li>
										</ul>
									</div>
								</div>
								<div className="col-xl-3 col-lg-3 col-md-6">
									<div className="widget widget_form">
										<h3 className="footer-title">Subcribite a nuestro newsletter</h3>
										<form className="subscribe-form subscription-form mb-30">
											<div className="ajax-message"></div>
											<div className="input-group">
												<input name="email" required="required" className="form-control" placeholder="Ingresa tu correo electronico" type="email"/>
											</div>
											<button name="submit" value="Submit" type="submit" className="btn btn-secondary shadow w-100">Subscribirme</button>	
										</form>
										<div className="footer-social-link">
											<p>Nuestras redes sociales</p>
											<ul>
												{/* <li><a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/"><img src={facebook} alt=""/></a></li>
												<li><a target="_blank" rel="noopener noreferrer" href="https://twitter.com/"><img src={twitter} alt=""/></a></li> */}
												<li><a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/utopiadentalclinic"><img src={instagram} alt=""/></a></li>
												{/* <li><a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/"><img src={linkedin} alt=""/></a></li> */}
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="container">
						<div className="footer-bottom">
							<div className="row">
								<div className="col-12 text-center">
									<p className="copyright-text">Copyright © 2025 Powered by <a href="https://codilium.com" rel="noopener noreferrer" target="_blank" className="text">Codilium</a></p>
								</div>
							</div>
						</div>
					</div>
					<img className="pt-img1 animate-wave" src={ptImg1} alt=""/>
					<img className="pt-img2 animate1" src={ptImg2} alt=""/>
					<img className="pt-img3 animate-rotate" src={ptImg3} alt=""/>
					<img className="pt-img4 animate-wave" src={ptImg4} alt=""/>
				</footer>
			
			</>
		);
	}
}

export default aboutSection;